"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.apiErrorSchema = exports.paginationMetaSchema = void 0;
const zod_1 = require("zod");
// Every API response uses one of these two shapes (CLAUDE.md §10). Defined once
// here so the API serialiser and the web client can never drift apart.
exports.paginationMetaSchema = zod_1.z.object({
    page: zod_1.z.number().int().positive(),
    pageSize: zod_1.z.number().int().positive(),
    total: zod_1.z.number().int().nonnegative(),
});
exports.apiErrorSchema = zod_1.z.object({
    code: zod_1.z.string().min(1),
    message: zod_1.z.string().min(1),
    requestId: zod_1.z.string().min(1).optional(),
    details: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).optional(),
});
//# sourceMappingURL=api-envelope.js.map